export default __webpack_public_path__ + "static/media/dd11fab3-60c5-4778-b853-ca291e37e634.98091fee.jpg";